import { getContextId } from '@tlx/astro-shared';

const TESTBRUKER_TESTESEN_FULL_PAKKE = 486505;
const EDAG_TEST_PREBEN_FROGNER = 3759310; // Gjerdrum og Sørstraumen Revisjon
const FORNOYD_KOMISK_TIGER = 54206943; //TSK test company accountant | tsk.tripletex+RF@gmail.com
const GRONN_SPONTANT_TIGER = 44336218; // TSK test company (orgnum 210499822) | tsk.tripletex+tenor@gmail.com
const SJENERT_PESSIMISTISK_TIGER = 54208041; // TSK test company client | tsk.tripletex+KL@gmail.com
const TEST_OMO_BYRA = 4554019;

const TSK_COMPANIES = [
    EDAG_TEST_PREBEN_FROGNER,
    TESTBRUKER_TESTESEN_FULL_PAKKE,
    FORNOYD_KOMISK_TIGER,
    GRONN_SPONTANT_TIGER,
    SJENERT_PESSIMISTISK_TIGER,
    TEST_OMO_BYRA,
];

export function isTSKCompany() {
    const contextId = parseInt(getContextId() ?? '');
    return TSK_COMPANIES.includes(contextId);
}

export function isTSKCompanyOrFullPakke() {
    const contextId = parseInt(getContextId() ?? '');
    return isTSKCompany() || contextId === TESTBRUKER_TESTESEN_FULL_PAKKE;
}
